import { mapGetters } from 'vuex';
import { LOGOUT } from '@/store/modules/auth/authActions.type';

export default {
  computed: {
    ...mapGetters([
      'isAuthenticated',
      'user',
      'isAdmin',
    ]),
  },
  methods: {
    logout() {
      this.$store.dispatch(LOGOUT)
        .then((response) => {
          this.$log.info('LOGOUT', response);
        })
        .catch((error) => {
          this.$log.error('LOGOUT', error);
        });
    },
  },
};
